import PlanChangeConfirmationModal from './PlanChangeConfirmationModal.component';
import PlanChangedSuccessfulModal from './PlanChangedSuccessfulModal.component';
import { UpgradeMessage } from './UpgradeMessage.component';
import UpgradePlanModal from './UpgradePlanModal.component';
import UpgradePlanOrdersAndProductsContent from './UpgradePlanOrdersAndProductsContent.component';

export default {
	PlanChangeConfirmationModal,
	PlanChangedSuccessfulModal,
	UpgradeMessage,
	UpgradePlanModal,
	UpgradePlanOrdersAndProductsContent,
};
